import { useSelector } from "react-redux";
import { STATUS } from "../../constants/status.constant";
import { Tag } from "antd";
import { RootState } from "../../store/store";
import placeholder from "../../assets/placeholder.png";
import { dateTimeDisplayFormat } from "../../utils/DateAndTimeConvertor";
import { EnvironmentOutlined } from "@ant-design/icons";
import { getEventVenueLabel } from "../../utils/eventDisplay";
import EventRejectionSidebarRemark from "../EventRejectionAlert";

const EventCard = () => {
  const event = useSelector((state: RootState) => state.event);
  const venueLabel = getEventVenueLabel(event);

  const imageUrl = Array.isArray(event?.banner_image)
    ? event?.banner_image?.[0]?.url
    : event?.banner_image;

  return (
    <div className="sidebar-event-header">
      {imageUrl && (
        <img
          src={imageUrl}
          alt={event?.name}
          className="w-full object-cover rounded-[8px] max-h-[72px] mb-[10px]"
          onError={(e) => {
            (e.target as HTMLImageElement).src = placeholder;
          }}
        />
      )}
      <div className="flex items-start justify-between gap-[8px]">
        <p className="event-name flex-1">{event?.name}</p>
        {event?.status && (
          <Tag
            className="!text-[10px] !px-[6px] !py-0 !h-[18px] !leading-[18px] capitalize shrink-0 !m-0"
            color={STATUS[event.status as keyof typeof STATUS]?.bg || "default"}
            bordered={false}
          >
            {event.status}
          </Tag>
        )}
      </div>
      {venueLabel && (
        <p
          className="event-date"
          style={{ display: "flex", alignItems: "center", gap: 4 }}
        >
          <EnvironmentOutlined style={{ fontSize: 11 }} />
          <span className="line-clamp-1">{venueLabel}</span>
        </p>
      )}
      {event?.start_date && (
        <p className="event-date">
          {dateTimeDisplayFormat(event.start_date, event.start_time)}
        </p>
      )}
      <EventRejectionSidebarRemark />
    </div>
  );
};

export default EventCard;
